"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FromBoumWireClaimsV1 = FromBoumWireClaimsV1;
const boum_claims_1 = require("./boum-claims");
const boum_right_1 = require("./boum-right");
const claims_1 = require("./claims");
var BoumClaimV1Names;
(function (BoumClaimV1Names) {
    /** comma-separated */
    BoumClaimV1Names["USERRIGHTS"] = "userRights";
    /** comma-separated */
    BoumClaimV1Names["TENANTS"] = "custom:tenants";
    /** comma-separated */
    BoumClaimV1Names["CUSTOMER_TENANTS"] = "custom:customerTenants";
    /** comma-separated */
    BoumClaimV1Names["OPERATOR_TENANTS"] = "custom:operatorTenants";
    /** comma-separated */
    // TODO: remove optional after it's certain that everyone has a new token
    /** comma-separated */
    BoumClaimV1Names["SERVICE_AREAS"] = "custom:serviceAreas";
    // boum user id
    BoumClaimV1Names["USER_ID"] = "custom:userId";
    // backoffice username
    BoumClaimV1Names["BACKOFFICE_USER_NAME"] = "custom:backofficeUsername";
    BoumClaimV1Names["SYSTEM_USER"] = "custom:systemUser";
})(BoumClaimV1Names || (BoumClaimV1Names = {}));
function ToBoumWireClaimsV1(claims) {
    const ret = {};
    if ((0, claims_1.isSome)(claims.userRights)) {
        ret[BoumClaimV1Names.USERRIGHTS] = claims.userRights.val.toString();
    }
    if ((0, claims_1.isSome)(claims.tenants)) {
        ret[BoumClaimV1Names.TENANTS] = (0, claims_1.toString)(claims.tenants);
    }
    if ((0, claims_1.isSome)(claims.customerTenants)) {
        ret[BoumClaimV1Names.CUSTOMER_TENANTS] = (0, claims_1.toString)(claims.customerTenants);
    }
    if ((0, claims_1.isSome)(claims.operatorTenants)) {
        ret[BoumClaimV1Names.OPERATOR_TENANTS] = (0, claims_1.toString)(claims.operatorTenants);
    }
    if ((0, claims_1.isSome)(claims.serviceAreas)) {
        ret[BoumClaimV1Names.SERVICE_AREAS] = (0, claims_1.toString)(claims.serviceAreas);
    }
    if ((0, claims_1.isSome)(claims.userId)) {
        ret[BoumClaimV1Names.USER_ID] = (0, claims_1.toString)(claims.userId);
    }
    if ((0, claims_1.isSome)(claims.backofficeUsername)) {
        ret[BoumClaimV1Names.BACKOFFICE_USER_NAME] = (0, claims_1.toString)(claims.backofficeUsername);
    }
    if ((0, claims_1.isSome)(claims.isSystemUser)) {
        ret[BoumClaimV1Names.SYSTEM_USER] = (0, claims_1.boolean2String)(claims.isSystemUser);
    }
    return ret;
}
function requiredRightArrayAttribute(claims, attribute, ec) {
    const value = (0, claims_1.requiredStringArrayAttribute)(claims, attribute, [], ec);
    return claims_1.WithDefault.from(boum_right_1.BoumRightEnDeCoder.toPermissions(value.val, ec), boum_right_1.BoumRightEnDeCoder.toPermissions());
}
function FromBoumWireClaimsV1(claims, defaults = {}) {
    const withDefaults = { ...ToBoumWireClaimsV1((0, boum_claims_1.toEntity)(defaults)), ...claims };
    const ec = new claims_1.ErrorCollector('boum');
    return new boum_claims_1.BoumClaimsImpl(ec, {
        version: 'V1',
        userRights: requiredRightArrayAttribute(withDefaults, BoumClaimV1Names.USERRIGHTS, ec),
        tenants: (0, claims_1.requiredStringArrayAttribute)(withDefaults, BoumClaimV1Names.TENANTS, [], ec),
        customerTenants: (0, claims_1.requiredStringArrayAttribute)(withDefaults, BoumClaimV1Names.CUSTOMER_TENANTS, [], ec),
        operatorTenants: (0, claims_1.requiredStringArrayAttribute)(withDefaults, BoumClaimV1Names.OPERATOR_TENANTS, [], ec),
        ridepoolingServiceTenants: claims_1.WithDefault.from(null, []),
        fleets: claims_1.WithDefault.from(null, []),
        serviceAreas: (0, claims_1.requiredStringArrayAttribute)(withDefaults, BoumClaimV1Names.SERVICE_AREAS, [], ec),
        userId: (0, claims_1.requiredStringAttribute)(withDefaults, 'custom:userId', '', ec),
        backofficeUsername: (0, claims_1.requiredStringAttribute)(withDefaults, BoumClaimV1Names.BACKOFFICE_USER_NAME, '', ec),
        isSystemUser: (0, claims_1.requiredBooleanAttribute)(withDefaults, BoumClaimV1Names.SYSTEM_USER, false, ec),
    }, ToBoumWireClaimsV1);
}
//# sourceMappingURL=boum-claims-v1.js.map